<template>
  <mt-popup
    v-model="isVisible"
    position="bottom"
    :closeOnClickModal="false"
    v-clickoutside="closePopup"
  >
    <div class="m-cart-picker-title">
      <span>选择产品</span>
      <i class="m-cart-picker-close"></i>
    </div>
    <div class="m-cart-picker-goods">
      <div class="m-cart-picker-goods-gallery">
        <el-image :src="goods.thumbnail" :fit="'contain'"></el-image>
      </div>
      <div class="m-cart-picker-goods-info">
        <span class="m-cart-picker-goods-title">
          {{ goods.title }}
        </span>
        <div class="m-cart-picker-goods-opt">
          <span class="m-cart-picker-goods-price">
            <em>￥</em>{{ price_type == 1 ? price : agreement_price }}
          </span>
          <span class="m-cart-picker-goods-qty">库存：{{ storage > 0 ? '有货' : '无货' }}</span>
          <el-input-number
            :key="inputKey"
            style="width: 2rem"
            :value="inputNumber"
            :min="start_order_num"
            :max="storage - (storage % start_order_num)"
            :step="start_order_num == 0 ? 1 : start_order_num"
            size="mini"
            @change="handleChange($event)"
          ></el-input-number>
        </div>
      </div>
    </div>
    <div class="m-cart-picker-goods-attr-content">
      <ul
        class="m-cart-picker-goods-attr"
        v-for="(item, index) in goods_specs"
        :key="index"
      >
        <li class="m-cart-picker-goods-attr-item">
          <label class="m-cart-picker-goods-attr-name">{{
            item.spec_name
          }}</label>
          <div class="m-cart-picker-goods-attr-wrapper">
            <span
              class="m-cart-picker-goods-attr-btn"
              v-for="(citem, cindex) in item.items"
              :key="cindex"
              :class="{ active: item.specIndex == cindex,'is_enable':isEnableSpec(index,cindex) }"
              @click="specClick(item,index,cindex)"
              >{{ citem.item_value }}</span
            >
          </div>
        </li>
      </ul>
    </div>
    <div class="m-cart-picker-goods-add-opt">
      <mt-button class="m-cart-picker-goods-button" @click="addToCar"
        >加入购物车</mt-button
      >
      <mt-button
        class="m-cart-picker-goods-button danger"
        @click="purchaseRightNow"
        >立即购买</mt-button
      >
    </div>
  </mt-popup>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { Toast } from "mint-ui";
export default {
  name: "MyCartPicker",
  components: {},
  data() {
    return {
      goods_id: 0,
      goods: {},
      goods_specs: [],
      spec_prices: [],
      storage: 0,
      start_order_num: 1,
      inputNumber: 0,
      price: 0,
      price_type: 0,
      agreement_price: 0,
      inputKey: 0,
      spec_prices_sift: [],
      isLoad: false,
      address_id: this.$route.query.address_id || 0,
    };
  },
  props: {
    isVisible: false,
  },
  computed: {
    ...mapGetters("user", ["isLogin"]),
  },
  methods: {
    closePopup() {
      this.$emit("update:isVisible", false);
    },
    sendId(id) {
      this.goods_id = id;
      if (!this.isLoad) {
        this.getGoodsDetail();
        this.getGoodsSpec();
      }
    },
    getGoodsDetail() {
      const { goods_id } = this;
      this.$.http
        .post("goods/detail", {
          goods_id,
        })
        .then((res) => {
          const { data } = res;
          const { goods } = data;
          this.goods = goods;
          this.isLoad = true;
        });
    },
    getGoodsSpec() {
      const { goods_id } = this;
      this.$.http.post("goods/goodsSpecs", { goods_id }).then((res) => {
        const { goods_specs, spec_prices } = res.data;
        this.goods_specs = goods_specs
        this.spec_prices = spec_prices
        const key_id = Object.values(this.spec_prices).find(item => item.storage != 0).key || ''
        const spec_prices_sift = Object.values(this.spec_prices).filter(item=>item['key'] == key_id)[0];
        const { item_id,storage,price_type,agreement_price,price,start_order_num } = spec_prices_sift
        const key_arr = key_id.split('-')
        if(key_arr.length){
          this.goods_specs =  Object.values(this.goods_specs).map((item,index) =>
            //激活默认有库存的
            Object.assign({...item,specIndex:item.items.findIndex(citem=> citem.item_key == key_arr[index])})
          )
        }
        this.specSelectId = item_id
        this.storage = storage
        this.price_type = price_type
        this.agreement_price = agreement_price
        this.price = price
        this.start_order_num = start_order_num == 0 ? 1 : start_order_num
        this.inputNumber = start_order_num  == 0 ? 1 : start_order_num
        this.inputKey += 1;
        this.$emit("select", { attr: { ...spec_prices_sift } });
        this.$forceUpdate();
      });
    },
    specClick(item,index,cindex) {
      const key_id = this.goods_specs.map((item,mindex) => index == mindex ? item.items[cindex].item_key :item.items[item.specIndex || 0].item_key).join('-')
      const spec_prices_sift = this.spec_prices.filter(item=>item['key'] == key_id)[0];
      const { item_id,storage,price_type,agreement_price,price,start_order_num } = spec_prices_sift
      if(!storage){
        Toast({
          message: "暂无库存",
        });
        return
      }
      item.specIndex = cindex
      this.specSelectId = item_id
      this.storage = storage
      this.price_type = price_type
      this.agreement_price = agreement_price
      this.price = price
      this.start_order_num = start_order_num == 0 ? 1 : start_order_num
      this.inputNumber = start_order_num  == 0 ? 1 : start_order_num
      this.$emit("select", { attr: { ...spec_prices_sift } });
      this.$forceUpdate();
    },
    handleChange(ev) {
      this.inputNumber = ev;
      this.$emit("change", { num: ev });
    },
    // 加入购物车
    addToCar() {
      Toast({ message: "移动端网页暂不支持加购下单，请在电脑端继续。" });
      return;
      const { inputNumber, specSelectId, isLogin } = this;
      if (!isLogin) {
        Toast({
          message: "请先登录",
        });
        return;
      }
      if (specSelectId == "") {
        Toast({
          message: "更新购物车商品数量成功",
        });
        return false;
      }
      this.$store
        .dispatch("cart/AddCart", {
          item_id: specSelectId,
          num: inputNumber,
        })
        .then((res) => {
          const { code, message } = res;
          if (code == 200) {
            this.inputNumber = 1;
            this.$emit("update:isVisible", false);
            Toast({
              message: "添加成功",
            });
            // this.hide()
          } else {
            Toast({
              message,
            });
          }
        });
    },
    //立即购买
    purchaseRightNow() {
      Toast({ message: "移动端网页暂不支持加购下单，请在电脑端继续。" });
      return;
      const { goods_id, inputNumber, specSelectId, isLogin, address_id } = this;
      if (!isLogin) {
        Toast({
          message: "请先登录",
        });
        return;
      }
      const settle_type = 2;
      this.$router.push({
        path: "mOrderConfirm",
        query: {
          goods_id,
          num: inputNumber,
          item_id: specSelectId,
          settle_type,
          address_id,
        },
      });
    },
     isEnableSpec(index,cindex){
      const key_id = this.goods_specs.
        map((item,mindex) =>  index == mindex ?  item.items[cindex].item_key : item.items[item.specIndex || 0].item_key ).
        join('-')
      return Object.values(this.spec_prices).find(item => item.key == key_id).storage == 0
    },
  },
};
</script>

<style>
.mint-popup-bottom {
  width: 100%;
  padding: 0.2rem !important;
}

.m-cart-picker-goods {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  justify-content: center;
  padding: 0.2rem 0;
}

.m-cart-picker-goods-gallery {
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 0.2rem;
  border: 1px solid #efefef;
  border-radius: 0.2rem;
  padding: 0.1rem;
}

.m-cart-picker-goods-gallery img {
  width: 100%;
  height: 100%;
}

.m-cart-picker-goods-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight: bold;
  font-size: 0.26rem;
}

.m-cart-picker-goods-info {
  display: flex;
  flex-direction: column;
  width: 70%;
  justify-content: space-between;
  align-items: space-between;
  height: 100%;
}

.m-cart-picker-goods-opt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.15rem;
}

.m-cart-picker-title {
  display: block;
  width: 100%;
  text-align: center;
}

.m-cart-picker-title span {
  font-size: 0.3rem;
  font-weight: bold;
  display: block;
}

.m-cart-picker-goods-attr {
  padding: 0.2rem;
}

.m-cart-picker-goods-attr-name {
  font-size: 0.26rem;
  font-weight: 400;
}

.m-cart-picker-goods-price {
  color: #f00;
  font-weight: bold;
  font-size: 0.28rem;
}

.m-cart-picker-goods-attr-btn {
  display: block;
  border: 1px solid #ccc;
  float: left;
  padding: 0.1rem 0.4rem;
  margin-left: 0.2rem;
  border-radius: 0.5rem;
  margin-top: 0.2rem;
}

.m-cart-picker-goods-attr-btn.active {
  background: #f00;
  color: #fff;
  border-color: #f00;
}

.m-cart-picker-goods-attr-wrapper {
  overflow: hidden;
  margin-left: -0.2rem;
}

.m-cart-picker-goods-attr-content {
  max-height: 6.4rem;
  overflow: hidden;
  overflow-y: scroll;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  margin-bottom: 1rem;
  margin-top: 0.2rem;
}

.m-cart-picker-goods-add-opt {
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.m-cart-picker-goods-button {
  flex: 1;
  background: #000;
  color: #fff;
  border-radius: 0;
  padding: 0.1rem 0.4rem;
  display: block;
  margin: auto;
  font-size: 0.28rem;
}

.m-cart-picker-goods-button.danger {
  background: #f00;
  color: #fff !important;
}
.mint-toast.is-placemiddle {
  z-index: 999999;
}
.m-cart-picker-goods-attr-btn.is_enable{
  border: 1px dashed #D6D6D8 !important;
  color: #CDCDCD;
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/mobile/components/MyCartPicker/index.vue